import PropTypes from 'prop-types'
import React from 'react'

import head from 'lodash/head'

import ItemCard from '.'

function getImageAlt(item) {
  return item.name || item.refId
}

function CatalogItemCard({
  item,
  ean,
  maxQuantity,
  index,
  length,
  handleChangeItemQuantity,
  handleRemoveItem,
}) {
  const imageAlt = getImageAlt(item)
  const imageSrc = head(item.images).ImageUrl || imageAlt
  return (
    <ItemCard
      index={index}
      length={length}
      summaryMode={false}
      skuSpecifications={item.skuSpecifications}
      imageSrc={imageSrc}
      productName={item.productName}
      orderItemInconsistency={item.orderItemInconsistency}
      ean={ean}
      handleChangeItemQuantity={handleChangeItemQuantity}
      itemQuantity={item.quantity}
      maxQuantity={maxQuantity}
      handleRemoveItem={handleRemoveItem}
    />
  )
}

CatalogItemCard.propTypes = {
  item: PropTypes.object.isRequired,
  ean: PropTypes.string.isRequired,
  maxQuantity: PropTypes.number,
  index: PropTypes.number,
  length: PropTypes.number,
  handleChangeItemQuantity: PropTypes.func,
  handleRemoveItem: PropTypes.func,
  showPrice: PropTypes.bool,
}

export default CatalogItemCard
